module.exports = __webpack_public_path__ + "media/images/metronic/social/vimeo-12f23453201879ab2fdc31777bb73268.png";